import { Loader } from '@components/loader';
import { RawPreview } from '@components/rawPreview';
import { useGetCardAuth } from '@services/global/cardAuths/get';
import { createFileRoute, useParams } from '@tanstack/react-router';

const ApiResponse = () => {
  const { id } = useParams({
    from: '/u/$localId/_merchant/merchant/card-authentications/$id/apiResponse',
  });
  const { data, isPending } = useGetCardAuth(id);

  if (isPending) return <Loader />;

  return <RawPreview data={data} />;
};

export const Route = createFileRoute(
  '/u/$localId/_merchant/merchant/card-authentications/$id/apiResponse',
)({
  component: ApiResponse,
});
